import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import TodoService from 'services/TodoService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class EditCommentModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.commentID = opts.commentID;
            this.resolve = resolve;
            this.loginInfo = GlobalStateService.getValue('loginInfo');

            this.setState({
                isOpen: true,
                isLoading: true
            });
            this.load();
        });
    }

    close() {
        this.setState({
            isOpen: false
        });
    }

    async load() {
        // Load or create comment
        let comment;
        if (this.commentID) {
            comment = await TodoService.getComment(this.commentID);
        } else {
            comment = {
                ...this.opts
            };
        }

        // Update UI
        this.setState({
            comment,
            isLoading: false
        });
    }

    updateFields(values) {
        const comment = { ...this.state.comment };
        for (var field in values) {
            const value = values[field];
            if (value != comment[field]) {
                comment[field] = value;
            }
        }
        this.setState({ comment });
    }

    async saveAndClose() {
        const { comment } = this.state;
        this.setState({ isLoading: true });
        await TodoService.saveComment(comment);
        this.close();
        this.resolve();
    }

    async confirmDelete() {
        const confirm = await BootboxHelper.confirm(`Are you sure you want to delete this comment?`);
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({ isLoading: true });
        await TodoService.deleteComment(this.state.comment.id);
        this.close();
        this.resolve();
    }
    
    render() {
        const {
            isOpen
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="edit-comment-modal">
                {this.renderInner()}
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            comment
        } = this.state;

        if (isLoading) {
            return (
                <Modal.Body>
                    <Loader fullPage />
                </Modal.Body>
            );
        }

        return (

            <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                <Modal.Body>

                    <Form.Group className="">
                        <Form.Label>Comment</Form.Label>
                        <ExpandingTextArea
                            autoFocus={!comment.id}
                            className="form-control"
                            value={comment.text || ''}
                            rows="4"
                            onChange={e => this.updateFields({ text: e.target.value })}
                        /> 
                    </Form.Group>

                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                        Cancel
                    </button>
                    {comment.id &&
                        <button type="button" className="btn btn-danger ms-auto me-auto" onClick={() => this.confirmDelete()}>
                            Delete
                        </button>
                    }
                    <button type="submit" className="btn btn-primary ms-auto">
                        Save
                    </button>
                </Modal.Footer>
            </form>
        );
    }
    
}

export default EditCommentModal;